import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const TOPUP_THRESHOLD = 200;
const RETRY_COOLDOWN_MS = 10 * 60 * 1000;

/**
 * Se os pendentes do SDR ficarem em 200 ou menos, completa só a fila dele.
 * Sem polling: reage às atualizações normais dos contadores (após cada ligação).
 */
export function useOutboundAutoTopup(sdrId: string | undefined, pending: number | undefined) {
  const queryClient = useQueryClient();
  const runningRef = useRef(false);
  const lastRunRef = useRef(0);

  useEffect(() => {
    if (!sdrId || pending === undefined || pending > TOPUP_THRESHOLD) return;
    if (runningRef.current || Date.now() - lastRunRef.current < RETRY_COOLDOWN_MS) return;

    runningRef.current = true;
    lastRunRef.current = Date.now();
    supabase.functions
      .invoke('outbound-topup', { body: { sdr_id: sdrId } })
      .then(({ error }) => {
        if (error) console.error('[OutboundAutoTopup] Falha ao completar fila:', error);
        queryClient.invalidateQueries({ queryKey: ['outbound-queue'] });
        queryClient.invalidateQueries({ queryKey: ['outbound-stats-db'] });
        queryClient.invalidateQueries({ queryKey: ['outbound-batches'] });
      })
      .finally(() => {
        runningRef.current = false;
      });
  }, [sdrId, pending, queryClient]);
}
